export default __webpack_public_path__ + "static/media/ogc-construction-green-outline-separate-paths-compound-2-layers.2a953da4.svg";